import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import * as React from "react";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function ProductCardSkeleton() {
  return (
    <Box sx={{ width: "100%", padding: "4em" }}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        className="cursorPointer"
      >
        <Grid
          item
          xs={12}
          style={{
            border: "1px solid #E0E0E0",
            textAlign: "center",
            padding: "20px ",
            borderRadius: "6px",
            justifyContent: "center",
          }}
        >
          <Skeleton animation={"wave"} height={100} width={100} />
        </Grid>

        <Grid
          item
          xs={12}
          container
          style={{ textAlign: "justify", margin: "20px" }}
        >
          <Grid item xs={12} style={{ marginBottom: "10px" }}>
            <Skeleton animation={"wave"} />
          </Grid>
          <Grid item xs={12} style={{ color: "#F06292", marginBottom: "10px" }}>
            <Skeleton animation={"wave"} />
          </Grid>
          <Grid item xs={12} sm={6} style={{ color: "#64B5F6" }}>
            <Skeleton animation={"wave"} />
          </Grid>{" "}
        </Grid>
      </Grid>
    </Box>
  );
}
